import { globals } from './globals'
// import { colors } from './colors'
import { s } from '../constants/sizes'
// import { alpha } from '../constants/alpha'

export const sHtml = {
  maxWidth: globals.maxWidth,
  overflow: 'hidden',
  [s.sm_down]: {
    marginTop: globals.spacing.outside.mobile,
    padding: globals.spacing.inside.mobile,
    // boxShadow: globals.shadows.sections.mobile,
    // borderRadius: globals.roundness.sections.mobile,
  },
  [s.md]: {
    margin: '0 auto',
    marginTop: globals.spacing.between.desktop,
    padding: globals.spacing.inside.desktop,
    // boxShadow: globals.shadows.sections.desktop,
    // borderRadius: globals.roundness.sections.desktop,
  },

  p: {
    opacity: 0.6,
    lineHeight: '1.62em',
    margin: '1rem 0',
  },

  h1: {
    textAlign: 'center',
    paddingBottom: '2rem',
  },

  'ol, ul': {
    paddingInlineStart: '1rem',
  },
  table: {
    maxWidth: '100vw',
    fontSize: '0.75rem',
    textAlign: 'left',
    borderCollapse: 'collapse',
    width: '100%',
    margin: '0 0 30px',
    boxSizing: 'border-box',
    border: '1px solid rgba(167, 167, 167, .2) !important',
    overflow: 'scroll',
  },
  td:{
    padding: '30px 5px',
    border: '1px solid rgba(167, 167, 167, .2) !important',
  }
}
